import BaseModel from '../BaseModel';
import ReferenceEventLog from './ReferenceEventLog';

export default class BaseEventPayload extends BaseModel {
  constructor(classType, payloadData = {}, parentEventLog) {
    super(classType, payloadData);
    this.parentEventLog = new ReferenceEventLog(parentEventLog);
  }
}
